export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2022.b47ded72.pdf";